import React, { FC, useState } from 'react'
import Modal from '../common/Modal'

import '../../assets/scss/first_introduction.scss'

interface IntroModalProps {
  isOpen: boolean
  onCloseModal: () => void
}
const TeamDailyIntro: FC<IntroModalProps> = (props) => {
  const { isOpen, onCloseModal } = props
  const initialIntro = {
    show: isOpen,
    currentPage: 0,
  }
  const [intro, setIntro] = useState(initialIntro)

  const handleNextIntro = () => {
    setIntro({
      ...intro,
      currentPage: intro.currentPage + 1,
    })
  }

  const handlePrevIntro = () => {
    setIntro({
      ...intro,
      currentPage: intro.currentPage - 1,
    })
  }

  const handleCloseIntro = () => {
    setIntro({
      show: false,
      currentPage: 0,
    })
    onCloseModal()
  }

  const renderIntroModal1 = () => (
    <>
      <h1 className="intro-title">チームレポートページ(日次)の見方</h1>
      <div className="intro-body">
        <div className="intro-description">
          <h3>
            チームレポート(日次)ではメンバーそれぞれの作業内容や、チーム全体の傾向を確認できます。
          </h3>
          <h3 className="intro-sample">サンプルデータ</h3>
          <img
            alt="team_daily_report_1"
            src="/static/images/firstIntroduction/team_report/daily/1.png"
            style={{ border: 'solid 3px #878c9a', borderRadius: '10px', width: '100%', height: '70%' }}
            className="sample-image"
          />
        </div>
      </div>
    </>
  )

  const renderIntroModal2 = () => (
    <>
      <h1 className="intro-title">作業内容の表示切り替え</h1>
      <div className="intro-body">
        <div className="intro-description">
          <h3>
            作業内容は分類別、アプリ別の表示を切り替えることができます。
            <br />
            また、棒グラフをクリックすると該当の分類、アプリでフィルタリングされた状態の個人レポートへ遷移します。
          </h3>
          <h3 className="intro-sample">作業内容(分類別)</h3>
          <img
            alt="team_daily_report_2"
            src="/static/images/firstIntroduction/team_report/daily/2.png"
            style={{ border: 'solid 3px #878c9a', borderRadius: '10px', width: '100%' }}
            className="sample-image"
          />
          <h3 className="modal-sample">作業内容(アプリ別)</h3>
          <img
            alt="team_daily_report_3"
            src="/static/images/firstIntroduction/team_report/daily/3.png"
            style={{ border: 'solid 3px #878c9a', borderRadius: '10px', width: '100%' }}
            className="sample-image"
          />
        </div>
      </div>
    </>
  )

  const renderIntroModal3 = () => (
    <>
      <h1 className="intro-title">その他各種機能</h1>
      <div className="intro-body">
        <div className="intro-description">
          <img
            alt="team_daily_report_3"
            src="/static/images/firstIntroduction/team_report/daily/4.png"
            style={{ border: 'solid 3px #878c9a', borderRadius: '10px', width: '100%' }}
            className="sample-image"
          />
          <h3 className="graph">①&nbsp;機能説明再表示</h3>
          <h4 className="graph-detail">この機能説明はこちらのアイコンをクリックすることでいつでも再表示できます。</h4>
          <h3 className="graph">②&nbsp;日次、月次切り替え</h3>
          <h4 className="graph-detail">こちらのタブから日次レポートと月次レポートを切り替えられます。</h4>
          <h3 className="graph">③&nbsp;日付変更</h3>
          <h4 className="graph-detail">
            表示するレポートの日付を会社登録日から昨日までの期間内で変えることができます。
            <br />
            <br />
            <span style={{ color: 'red' }}>※今日分のレポートをリアルタイムで見ることはできません。</span>
          </h4>
        </div>
      </div>
    </>
  )
  return (
    <Modal
      show={isOpen}
      modalSize="large"
      wrapperClass=""
      closeCallback={handleCloseIntro}
      closeable
    >
      <div className="introduction">
        { intro.currentPage === 0 && renderIntroModal1() }
        { intro.currentPage === 1 && renderIntroModal2() }
        { intro.currentPage === 2 && renderIntroModal3() }
      </div>
      <>
        {
          intro.currentPage !== 0 && (
            <button
              type="button"
              className="button"
              onClick={handlePrevIntro}
            >
              前の説明
            </button>
          )
        }
        {
          intro.currentPage === 2 ? (
            <button
              type="button"
              className="button complete"
              onClick={handleCloseIntro}
            >
              完了
            </button>
          ) : (
            <button
              type="button"
              className="button"
              onClick={handleNextIntro}
            >
              次の説明
            </button>
          )
        }
      </>
    </Modal>
  )
}

export default TeamDailyIntro
